import {Component, Input, OnInit} from '@angular/core';
import {OrderStatusUser} from '../../../../core/models/order.model';
import * as moment from 'moment/moment';

@Component({
  selector: 'app-order-completed-widget',
  templateUrl: './order-completed-widget.component.html',
  styleUrls: ['./order-completed-widget.component.scss'],
})
export class OrderCompletedWidgetComponent implements OnInit {
  @Input() public orderStatus: OrderStatusUser;

  public get orderNumber(): string {
    return `${this.orderStatus.order_number}`;
  }

  public get orderDate(): string {
    if (this.orderStatus.is_asap) {
      return ``;
    }
    const formattedDate = moment(this.orderStatus.pickup_at).format('dddd, MMMM Do, YYYY');
    return ` • Scheduled for ${formattedDate}`;
  }

  constructor(
  ) { }

  ngOnInit() {
  }

  public getTotalPrice(price: number): string {
    return (price / 100).toFixed(2);
  }

  public getModifiers(modifiers: any[]): string {
    return `Modifiers: ${modifiers.map(mod => mod.name).join(', ')}`;
  }
}
